import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const jjkellerConfig: TSPConfig = {
  key: 'jjkeller',
  name: 'JJ Keller',
  category: TSPCategory.CUSTOM,
  helpText: 'Input the credentials you use to log into the JJ Keller Web App.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default jjkellerConfig;
